import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import ScrollProgress from "@/components/ScrollProgress";
import CursorDynamic from "@/components/CursorDynamic";

function App() {
  return (
    <div className="App font-body bg-[#0A0A0A] text-white">
      <ScrollProgress />
      <CursorDynamic />
      <Toaster theme="dark" position="top-center" toastOptions={{
        style: {
          background: "#0A0A0A",
          border: "1px solid rgba(212,175,55,0.5)",
          color: "#fff",
          borderRadius: 0,
          fontFamily: "Manrope, sans-serif"
        }
      }} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
